import React, { useContext, useState } from "react";
import { Switch } from "react-router-dom";
import FormsContext from "./FormsContext";
import AppContext from "AppContext";
import PrivateRoute from "components/PrivateRoute";
import List from "./List";
import AddWizard from "./AddWizard";
import AddForm from "./AddForm";
import ViewForm from "./ViewForm";
import EditForm from "./EditForm";
import { useDispatch } from "react-redux";
import { notifyError, notifySuccess } from "redux/actions/Notifications";

function Forms() {
    const dispatch = useDispatch();

    const [addFormState, setAddFormState] = useState({
        category: undefined,
        form: undefined,
        client: undefined,
    });

    const setStatus = async (id, status, callback) => {
        try {
            const response = await FormClients.setStatusAsync({ id, status });
            callback(response.data);
            dispatch(notifySuccess("Status changed."));
        } catch (error) {
            dispatch(notifyError(error.response?.data?.message || error.message || "Unexpected error."));
        }
    };

    const {
        api: {
            Forms: { Forms, FormClients },
            General: { Storage },
            Management: { Customers },
        },
    } = useContext(AppContext);
    return (
        <FormsContext.Provider value={{ Forms, FormClients, Storage, Customers, addFormState, setAddFormState, setStatus }}>
            <Switch>
                <PrivateRoute exact path="/forms" component={List} />
                <PrivateRoute exact path="/forms/add/wizard" component={AddWizard} />
                <PrivateRoute exact path="/forms/add" component={AddForm} />
                <PrivateRoute exact path="/forms/:id" component={ViewForm} />
                <PrivateRoute exact path="/forms/:id/edit" component={EditForm} />
            </Switch>
        </FormsContext.Provider>
    );
}

export default Forms;
